import React from "react";
import { ImprovedParticipantShop } from "../../Interfaces/FundraiserRole";
import MobileProductCategoryDropdown from "./MobileProductCategoryDropdown";
import DesktopProductCategoryButtonBar from "./DesktopProductCategoryButtonBar";

interface ProductCategorySelectorProps {
  categories: string[];
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  participantShop: ImprovedParticipantShop;
  clothingCategoryCounts: {
    "Custom Hoodies": number;
    "Custom T-Shirts": number;
    "Custom Racerbacks": number;
  };
  sortedProductCategories: string[];
  handleCategorySelect: (category: string | null) => void;
  showClothingDropdown: boolean;
  selectedClothingCategory: string;
  handleClothingCategorySelect: (category: string) => void;
}

const ProductCategorySelector: React.FC<ProductCategorySelectorProps> = ({
  categories,
  selectedCategory,
  setSelectedCategory,
  participantShop,
  clothingCategoryCounts,
  sortedProductCategories,
  handleCategorySelect,
  showClothingDropdown,
  selectedClothingCategory,
  handleClothingCategorySelect,
}) => {
  return (
    <div className="row g-4 pt-4 pt-lg-5">
      <div className="col-12 d-block d-md-none mb-3">
        <MobileProductCategoryDropdown
          dropDownItems={categories}
          selected={selectedCategory}
          setSelected={setSelectedCategory}
          clothingCategories={[
            "Custom Hoodies",
            "Custom T-Shirts",
            "Custom Racerbacks",
          ]}
          categoryCounts={{
            ...categories.reduce(
              (acc, cat) => ({
                ...acc,
                [cat]: participantShop.sku_by_category[cat]?.length || 0,
              }),
              {}
            ),
            ...clothingCategoryCounts,
          }}
        />
      </div>
      <DesktopProductCategoryButtonBar
        sortedProductCategories={sortedProductCategories}
        selectedCategory={selectedCategory}
        handleCategorySelect={handleCategorySelect}
        showClothingDropdown={showClothingDropdown}
        selectedClothingCategory={selectedClothingCategory}
        handleClothingCategorySelect={handleClothingCategorySelect}
        clothingCategoryCounts={clothingCategoryCounts}
      />
    </div>
  );
};

export default ProductCategorySelector;
